"use client";
import { CircularProgress, Skeleton } from "@mui/material";

import "@/components/home/home.css";
import { InlineDiv } from "@/common/divs";
import PageContent from "@/components/home";
import { useLocation } from "@/hooks/useLocation";
import { PRIMARY_BUTTON_COLOR } from "@/utils/constants";

const PrerenderActivities = () => {
  const { latitude, longitude, city, isLoading } = useLocation();

  return isLoading ?
      <InlineDiv
        paddingY="200px"
        style={{ justifyContent: "center", minHeight: "400px" }}
      >
        <CircularProgress style={{ color: PRIMARY_BUTTON_COLOR }} size={50} />
        <Skeleton variant="rectangular" height={2400} animation={"wave"} />
      </InlineDiv>
    : <PageContent latitude={latitude} longitude={longitude} city={city} />;
};

export default PrerenderActivities;
